export default "__VITE_ASSET__3eb3e1d6__"